import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ImpressionTabs from './ImpressionTabs';
import Radiograph from './Radiograph';
import Photos from './Photos';
import style from './NewPatientPhotos.module.css';
import { connect } from 'react-redux';
import * as actionTypes from '../../../store/NewPatient/actionType';
import NewPatientHandleUpload from '../../../util/NewPatientHandleUpload';
import { withLang } from '../../../util/lang';
import { validateImpressionFiles } from '../NewPatientUtill';
import { openModal } from '../../../store/Global/global';

class NewPatientPhotos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dbxFileCount: 0,
        };
    }

    invert(image_id, invert) {
        this.props.handleInvertImage(image_id, invert);
    }

    handleRoatate(image_id, degree) {
        this.props.handleRoatateImage(image_id, degree);
    }

    handleEnableChoose3dFileChange(value) {
        this.props.handleEnableChoose3dFile(value);
    }

    handleChoose3dFile(value) {
        this.props.handleChoose3dFile(value);
    }

    checkIfImageExists(image_id) {
        let image_data = this.props.files.filter((imageObj) => {
            return imageObj.id == image_id;
        });
        return image_data[0].uploaded;
    }

    getImage(image_id) {
        let image_data = this.props.files.filter((imageObj) => {
            return imageObj.id == image_id;
        });
        return image_data[0];
    }

    handleUpload(image_id, file, platform = undefined) {
        NewPatientHandleUpload(image_id, file, this.props.handleDataFileUpload, platform);
        if (image_id === 'face_front_with_smile' && file !== 'remove' && this.props.parent !== 'refinement') {
            // check if the user wants to replace the profile pic with the frontal photo
            if (this.props.NewPaitientData.patientPhoto?.data || this.props.NewPaitientData.patientPhoto?.dataURL) {
                this.props.alertUserReplaceProfilePic({
                    modalCallbackFunc: () => this.props.handleFrontalPhotoToProfilePic(file),
                    title: this.get('warning.replace_patient_profile_pic_title'),
                    message: this.get('warning.replace_patient_profile_pic'),
                });
            } else {
                this.props.handleFrontalPhotoToProfilePic(file);
            }
        }
        this.checkInvalid();
        this.forceUpdate();
    }

    handleChoose(doctor_app_file_id) {
        if (doctor_app_file_id == 0) {
            this.props.handleChoosePhotoSet(0, this.props.files);
        } else {
            this.props.NewPaitientData.draftFileList.map((v) => {
                if (v.doctor_app_file_id == doctor_app_file_id) {
                    this.props.handleChoosePhotoSet(v, this.props.files);
                }
            });
        }
    }

    /**
     * Validates the active New Patient upload tab.
     */
    checkInvalid() {
        if (this.props.tabMode === 'photos' && this.props.match.params.type !== 'RETAINER') {
            let counter = 0;
            this.props.NewPaitientData.files.forEach((v) => {
                if (
                    [
                        'jaw_side_with_smile',
                        'face_front_with_smile',
                        'teeth_side_without_smile',
                        'jaw_front_with_smile',
                        'teeth_side_with_smile',
                        'jaw_side_without_smile',
                        ...(this.props.displayFirstFitFlag ? ['big_smile_full_face_with_full_retractors'] : []),
                    ].includes(v.id) &&
                    !v.data &&
                    !v.upload_later &&
                    !v.will_not_upload
                ) {
                    counter += 1;
                }
            });
            if (counter) {
                this.props.ErrorData({ id: 'photo', msg: this.get('warning.mandatoryPhoto'), valid: false });
            } else {
                this.props.ErrorData({ id: 'photo', msg: '', valid: true });
            }
        } else if (this.props.tabMode === 'radiography') {
            let counter = 0;
            this.props.NewPaitientData.files.forEach((v, index) => {
                if (
                    v.category === 'radio' &&
                    v.id === 'front_with_smile' &&
                    !v.data &&
                    !v.upload_later &&
                    !v.will_not_upload
                ) {
                    counter += 1;
                }
            });
            if (counter) {
                this.props.ErrorData({ id: 'radiograph', msg: this.get('warning.mandatoryRadiograph'), valid: false });
            } else {
                this.props.ErrorData({ id: 'radiograph', msg: '', valid: true });
            }
        } else if (this.props.tabMode === 'impression') {
            switch (this.props.NewPaitientData.impressionType) {
                case 'FILE': {
                    const impressionFiles = this.props.NewPaitientData.files.filter((v) => v.category === 'stl_file');
                    const impressionErrList = validateImpressionFiles(impressionFiles);
                    if (impressionErrList.length > 0) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.allStl'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
                case 'COURIER': {
                    if (String.isBlank(this.props.NewPaitientData.modernCode)) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.courier'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
                case 'SCANNER': {
                    if (
                        String.isBlank(this.props.NewPaitientData.scannerBrand) ||
                        String.isBlank(this.props.NewPaitientData.doctorId)
                    ) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.scanner'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
            }
        }
    }

    /**
     * Validates all required New Patient uploads.
     */
    checkAllInvalid() {
        if (this.props.match.params.type !== 'RETAINER') {
            if (
                this.props.NewPaitientData.files.some(
                    (v) =>
                        [
                            'jaw_side_with_smile',
                            'face_front_with_smile',
                            'teeth_side_without_smile',
                            'jaw_front_with_smile',
                            'teeth_side_with_smile',
                            'jaw_side_without_smile',
                            ...(this.props.displayFirstFitFlag ? ['big_smile_full_face_with_full_retractors'] : []),
                        ].includes(v.id) &&
                        !v.data &&
                        !v.upload_later &&
                        !v.will_not_upload
                )
            ) {
                this.props.ErrorData({ id: 'photo', msg: this.get('warning.mandatoryPhoto'), valid: false });
            } else {
                this.props.ErrorData({ id: 'photo', msg: '', valid: true });
            }
        }

        if (
            this.props.NewPaitientData.files.some(
                (v) =>
                    v.category === 'radio' &&
                    v.id === 'front_with_smile' &&
                    !v.data &&
                    !v.upload_later &&
                    !v.will_not_upload
            )
        ) {
            this.props.ErrorData({ id: 'radiograph', msg: this.get('warning.mandatoryRadiograph'), valid: false });
        } else {
            this.props.ErrorData({ id: 'radiograph', msg: '', valid: true });
        }

        switch (this.props.NewPaitientData.impressionType) {
            case 'FILE':
                const impressionFiles = this.props.NewPaitientData.files.filter((v) => v.category === 'stl_file');
                const impressionErrList = validateImpressionFiles(impressionFiles);
                if (impressionErrList.length > 0) {
                    this.props.ErrorData({ id: 'impression', msg: this.get('warning.allStl'), valid: false });
                } else {
                    this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                }
                break;
            case 'COURIER':
                if (String.isBlank(this.props.NewPaitientData.modernCode)) {
                    this.props.ErrorData({ id: 'impression', msg: this.get('warning.courier'), valid: false });
                } else {
                    this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                }
                break;
            case 'SCANNER':
                if (
                    String.isBlank(this.props.NewPaitientData.scannerBrand) ||
                    String.isBlank(this.props.NewPaitientData.doctorId)
                ) {
                    this.props.ErrorData({ id: 'impression', msg: this.get('warning.scanner'), valid: false });
                } else {
                    this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                }
                break;
        }
    }

    handleUseFiles(value) {
        this.props.handleUseFiles(value);
        this.checkAllInvalid();
    }

    /**
     * Renders the New Patient upload sections.
     */
    render() {
        return (
            <ul className={style.patientImages}>
                {this.props.tabMode == 'photos' && (
                    <>
                        <Photos
                            mode={this.props.mode}
                            imageUploaded={(value) => this.checkIfImageExists(value)}
                            imageData={(value) => this.getImage(value)}
                            parent={this.props.parent ? this.props.parent : 'main'}
                            uploadLater={this.props.uploadLater == 'patientInfo' ? false : true}
                            handleChange={(value, file) => {
                                this.handleUpload(value, file);
                            }}
                            invert={(value, invert) => {
                                this.invert(value, invert);
                            }}
                            handleRoatate={(value, degree) => {
                                this.handleRoatate(value, degree);
                            }}
                            handleChoose={(id) => {
                                this.handleChoose(id);
                            }}
                            checkInvalid={this.checkInvalid.bind(this)}
                            draftFileList={this.props.NewPaitientData.draftFileList}
                            chosenDraftFile={this.props.NewPaitientData.chosenDraftFile}
                            enableRaySelectChoose3dFile={this.props.NewPaitientData.enableRaySelectChoose3dFile}
                            handleEnableChoose3dFileChange={(value) => this.handleEnableChoose3dFileChange(value)}
                            handleChoose3dFile={(value) => this.handleChoose3dFile(value)}
                            handleUseFiles={(value) => this.handleUseFiles(value)}
                            facialScan={this.props.NewPaitientData.facialScan}
                            handleFacialScan={(value) => this.props.handleFacialScan(value)}
                            rayFiles={this.props.rayFiles}
                            caseRfsId={this.props.NewPaitientData.caseRfsId}
                            isRayCase={this.props.NewPaitientData.isRayCase}
                        />{' '}
                    </>
                )}

                {this.props.tabMode == 'radiography' && (
                    <>
                        <h3 className={style.heading}>{this.get('radiographs.uploadRadiograph')}</h3>
                        <Radiograph
                            mode={this.props.mode}
                            parent={this.props.parent ? this.props.parent : 'main'}
                            imageUploaded={(value) => this.checkIfImageExists(value)}
                            imageData={(value) => this.getImage(value)}
                            case_type={this.props.case_type}
                            uploadLater={this.props.uploadLater == 'patientInfo' ? false : true}
                            handleChange={(value, file) => {
                                this.handleUpload(value, file);
                            }}
                            handleRoatate={(value, degree) => {
                                this.handleRoatate(value, degree);
                            }}
                            checkInvalid={this.checkInvalid.bind(this)}
                            case_id={this.props.match.params.id}
                            dbxFileCount={this.state.dbxFileCount}
                            setDbxFileCount={(newDbxFileCount) => this.setState({ dbxFileCount: newDbxFileCount })}
                        />
                    </>
                )}

                {this.props.tabMode == 'impression' && (
                    <>
                        <h3 className={style.heading}>{this.get('impressions.uploadImpression')}</h3>
                        <div className={style.tabWrap}>
                            <ImpressionTabs
                                mode={this.props.mode}
                                imageUploaded={(value) => this.checkIfImageExists(value)}
                                uploadLater={this.props.uploadLater == 'patientInfo' ? 'patientInfo' : 'other'}
                                imageData={(value) => this.getImage(value)}
                                handleChange={(value, file, platform) => {
                                    this.handleUpload(value, file, platform);
                                }}
                                checkInvalid={this.checkInvalid.bind(this)}
                                threeshapeConnected={this.props.threeshapeConnected}
                                handleThreeshapeConnected={(value) => this.props.handleThreeshapeConnected(value)}
                            />
                        </div>
                    </>
                )}
            </ul>
        );
    }
}

/**
 * Maps Redux state to New Patient Photos props.
 */
const mapStateToProps = (store) => {
    return {
        files: store.newPatientReducer.files,
        NewPaitientData: store.newPatientReducer,
        lang: store.lang,
        displayFirstFitFlag: store.globalReducer.displayFirstFitFlag,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleDataFileUpload: (id, value, platform) =>
            dispatch({ type: actionTypes.NEW_PATIENT_FILES, id: id, value: value, platform: platform }),
        handleInvertImage: (id, value) => dispatch({ type: actionTypes.NEW_PATIENT_FILE_INVERT, id: id, value: value }),
        handleRoatateImage: (id, value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_FILE_ROTATE, id: id, value: value }),
        handleChoosePhotoSet: (draftFile, currentFile) =>
            dispatch({ type: actionTypes.NEW_PATIENT_FILE_CHOOSE, draftFile, currentFile }),
        handleEnableChoose3dFile: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_ENABLE_RAY_CHOOSE_3dFILE, value: value }),
        handleChoose3dFile: (value) => dispatch({ type: actionTypes.NEW_PATIENT_3dFILE_CHOOSED, value: value }),
        handleUseFiles: (value) => dispatch({ type: actionTypes.NEW_PATIENT_RFS_USE_FILES, value: value }),
        handleFacialScan: (value) => dispatch({ type: actionTypes.NEW_PATIENT_FACIAL_SCAN, value: value }),
        handleFrontalPhotoToProfilePic: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_PHOTO, value: value }),
        ErrorData: (errorMsg) => dispatch({ type: 'NEW_PATIENT_DATA_ERROR', errorMsg: errorMsg }),
        alertUserReplaceProfilePic: (value) =>
            dispatch(
                openModal({
                    modalTitle: value.title,
                    modalMessage: value.message,
                    modalCallbackFunc: value.modalCallbackFunc,
                })
            ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLang(NewPatientPhotos, 'NewPatient')));
